import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('studyai_token');
    if (token) {
      auth.me()
        .then(res => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('studyai_token');
          localStorage.removeItem('studyai_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await auth.login({ email, password });
    localStorage.setItem('studyai_token', res.data.token);
    // ✅ Fetch fresh user data including updated streak
    const freshUser = await auth.me();
    setUser(freshUser.data);
    return res.data;
  };

  const signup = async (name, email, password) => {
    const res = await auth.signup({ name, email, password });
    localStorage.setItem('studyai_token', res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('studyai_token');
    localStorage.removeItem('studyai_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};